import { useAuth } from "../../auth/authContext.tsx";
import { useSuperAdminPanel } from "./SuperAdminPanelProvider.tsx";

const bannerStyle: React.CSSProperties = {
  position: "relative",
  zIndex: 1, // below overlays/modals/toasts — banner is in normal document flow, no high z needed
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  gap: "var(--space-3)",
  padding: "var(--space-1) var(--space-4)",
  background: "var(--color-warning)",
  color: "var(--color-warning-foreground)",
  fontSize: "var(--text-sm)",
  fontWeight: 600,
  flexShrink: 0,
};

const stopBtnStyle: React.CSSProperties = {
  padding: "2px var(--space-2)",
  fontSize: "var(--text-xs)",
  fontWeight: 600,
  border: "1px solid rgba(0,0,0,0.3)",
  borderRadius: "var(--radius-1)",
  background: "rgba(255,255,255,0.3)",
  color: "#000",
  cursor: "pointer",
};

export function ImpersonationBanner() {
  const { impersonation, setImpersonation, realSuperAdmin } = useAuth();
  const { openPanel, saHidden } = useSuperAdminPanel();

  if (!realSuperAdmin || !impersonation || saHidden) return null;

  const label =
    impersonation.mode === "user"
      ? `Impersonating: ${impersonation.impersonateUserName} (UID ${impersonation.impersonateUID})`
      : formatSelectOverrides(impersonation);

  return (
    <div style={bannerStyle}>
      <span>{label}</span>
      <button style={stopBtnStyle} onClick={() => setImpersonation(null)}>
        Stop
      </button>
      <button style={stopBtnStyle} onClick={() => openPanel("impersonate")}>
        Configure
      </button>
    </div>
  );
}

function formatSelectOverrides(imp: { overrideOperatorID?: number; overrideSuperAdmin?: boolean; overrideIngressGroups?: number[]; overrideUserGroups?: number[]; overrideIPAddress?: string }): string {
  const parts: string[] = [];
  if (imp.overrideOperatorID != null) parts.push(`Operator #${imp.overrideOperatorID}`);
  if (imp.overrideSuperAdmin === false) parts.push("SA off");
  if (imp.overrideIngressGroups?.length) parts.push(`${imp.overrideIngressGroups.length} ingress group(s)`);
  if (imp.overrideUserGroups?.length) parts.push(`${imp.overrideUserGroups.length} user group(s)`);
  if (imp.overrideIPAddress) parts.push(`IP ${imp.overrideIPAddress}`);
  return `Overrides: ${parts.join(", ") || "none"}`;
}
